// import CenterWrap from './styles';

import CenterWrap from 'components/CenterWrap';
import React from 'react';

export default () => {
  return <CenterWrap>Contato</CenterWrap>;
};
